module.exports = __webpack_public_path__ + "src/img/new.49fa91ab.svg";